
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import FinanceReports from '@/components/finance/FinanceReports';

const FinanceReportsPage = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8">
        <h1 className="text-3xl font-bold mb-8">Finance Reports</h1>
        
        <Card className="w-full">
          <CardHeader>
            <CardTitle>Finance Reports</CardTitle>
          </CardHeader>
          <CardContent>
            <FinanceReports />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default FinanceReportsPage;
